export interface INameToId {
  name: string;
  id: number;
}

export interface ICreateOrUpdateCatsResponse {
  cats: INameToId[];
}

export enum AbandonedCartFailureReason {
  USER_NOT_FOUND = "USER_NOT_FOUND",
  HAS_ALREADY_BEEN_CHARGED = "HAS_ALREADY_BEEN_CHARGED",
  HAS_CONFLICTING_PERMISSIONS = "HAS_CONFLICTING_PERMISSIONS",
  AC_INTERNAL_ERROR = "AC_INTERNAL_ERROR",
  CAT_DETAILS_CREATE_FAILED = "CAT_DETAILS_CREATE_FAILED",
  CAT_DETAILS_UPDATE_FAILED = "CAT_DETAILS_UPDATE_FAILED",
  OLD_DB_SYNC_FAILED = "OLD_DB_SYNC_FAILED",
  CUSTOMER_SUF_ANSWERS_EVENT_FAILED = "CUSTOMER_SUF_ANSWERS_EVENT_FAILED",
  CAT_SUF_ANSWERS_UPDATE_FAILED = "CAT_SUF_ANSWERS_UPDATE_FAILED",
  CAT_TO_BREEDER_UPDATE_FAILED = "CAT_TO_BREEDER_UPDATE_FAILED",
  CAT_SUF_ANSWERS_CREATE_FAILED = "CAT_SUF_ANSWERS_CREATE_FAILED",
  CAT_TO_BREEDER_CREATE_FAILED = "CAT_TO_BREEDER_CREATE_FAILED",
  LEFTOVER_CATS_DELETE_FAILED = "LEFTOVER_CATS_DELETE_FAILED",
  /** We were asked to update a cat with an ID but no cat was found with that ID
   * that belonged to the requested user. */
  CAT_NOT_FOUND_BY_ID = "CAT_NOT_FOUND_BY_ID",
  /** We were instructed that the creation of cats would not be necessary,
   * however, we determined that it was (e.g. because a cat with the given name
   * did not exist). */
  CREATION_REQUIRED = "CREATION_REQUIRED",
  /** A request was made to update cats that were already charged for fresh.
   * This is a bug and should never happen.
   * That might mean the user has somehow already successfully checked out
   * and is going through the SUF again
   * (though in that case you should have got the HAS_ALREADY_BEEN_CHARGED error first).
   * Another possibility is they somehow managed to select an already charged
   * cat for fresh cross-sell. */
  CANNOT_UPDATE_CHARGED_CATS = "CANNOT_UPDATE_CHARGED_CATS",
}

export interface ICreateOrUpdateCatsUnprocessableEntityResponse {
  reason: AbandonedCartFailureReason;
}
